var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5EEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.8086 14.2505H28.1686C27.9786 13.9805 27.7786 13.7305 27.5686 13.4805L26.8086 14.2505Z",
    fill: "#7B408C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.52 12.4203C26.27 12.2103 26.02 12.0103 25.75 11.8203V13.1803L26.52 12.4203Z",
    fill: "#7B408C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25 15.75C24.9 15.75 24.81 15.73 24.71 15.69C24.53 15.61 24.38 15.47 24.3 15.28C24.26 15.19 24.24 15.09 24.24 14.99V10.99C24.24 10.98 24.25 10.97 24.25 10.95C22.96 10.35 21.52 10 20 10C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30C25.52 30 30 25.52 30 20C30 18.48 29.65 17.04 29.04 15.74C29.03 15.74 29.02 15.75 29 15.75H25Z",
    fill: "#7B408C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5795 13.4795L30.5295 10.5295C30.8195 10.2395 30.8195 9.75945 30.5295 9.46945C30.2395 9.17945 29.7595 9.17945 29.4695 9.46945L26.5195 12.4195C26.8995 12.7494 27.2495 13.1095 27.5795 13.4795Z",
    fill: "#7B408C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7517 11C25.7517 10.59 25.4117 10.25 25.0017 10.25C24.6017 10.25 24.2817 10.57 24.2617 10.96C24.7817 11.21 25.2817 11.49 25.7517 11.82V11Z",
    fill: "#7B408C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7519 15C29.7519 14.59 29.4119 14.25 29.0019 14.25H28.1719C28.5019 14.72 28.7919 15.22 29.0319 15.74C29.4319 15.72 29.7519 15.4 29.7519 15Z",
    fill: "#7B408C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 19.82L20.75 19.47V17.25H20.83C21.34 17.25 21.75 17.7 21.75 18.25C21.75 18.66 22.09 19 22.5 19C22.91 19 23.25 18.66 23.25 18.25C23.25 16.87 22.17 15.75 20.83 15.75H20.75V15.5C20.75 15.09 20.41 14.75 20 14.75C19.59 14.75 19.25 15.09 19.25 15.5V15.75H18.95C17.74 15.75 16.75 16.77 16.75 18.03C16.75 19.49 17.6 19.96 18.25 20.19L19.25 20.54V22.76H19.17C18.66 22.76 18.25 22.31 18.25 21.76C18.25 21.35 17.91 21.01 17.5 21.01C17.09 21.01 16.75 21.35 16.75 21.76C16.75 23.14 17.83 24.26 19.17 24.26H19.25V24.51C19.25 24.92 19.59 25.26 20 25.26C20.41 25.26 20.75 24.92 20.75 24.51V24.26H21.05C22.26 24.26 23.25 23.24 23.25 21.98C23.25 20.51 22.4 20.04 21.75 19.82ZM18.74 18.76C18.4 18.64 18.25 18.57 18.25 18.02C18.25 17.59 18.57 17.24 18.95 17.24H19.25V18.93L18.74 18.76ZM21.05 22.75H20.75V21.06L21.26 21.24C21.6 21.36 21.75 21.43 21.75 21.98C21.75 22.4 21.43 22.75 21.05 22.75Z",
    fill: "#7B408C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.60f03922b0b4a6ae8d0438344bb0af0a.svg";
export { ForwardRef as ReactComponent };